import './App.css';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// pages
import PrivateRouter from "./components/PrivateRouter/PrivateRouter"
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';
import UserManagement from './components/UserManagement/userlist';
import UserDetail from './components/UserManagement/userDetails';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import RolesAndPermissions from './components/RolesAndPermissions/RolesAndPermissions';
import ManageRolesAndPermissions from './components/RolesAndPermissions/ManageRolesAndPermissions';
import CategoryManagement from './components/CategoryManagement/CategoryManagement';
import DropdownManagement from './components/DropdownManagement/DropdownManagement';
import CallLogs from './components/CallLogs/CallLogs';
import CallStatus from './components/CallStatus/CallStatus';
import ViewUsers from './components/RolesAndPermissions/ViewUsers';
import SettingsLayout from './components/Settings/Layout';
import EmailSettings from './components/Settings/EmailSettings';
import CallSettings from './components/Settings/CallSettings';
import KnowledgeBase from './components/KnowledgeBase/KnowledgeBase';


function App() {
  return (
    <React.Fragment>
      <BrowserRouter>

        <ToastContainer />

        <Routes>

          <Route path='/' element={<Login />} />
          <Route path='/forgotPassword' element={<ForgotPassword />} />
          <Route path="/resetPassword/:token" element={<ResetPassword />} />


          <Route element={<Layout />}>

            <Route path='/dashboard' element={<PrivateRouter />}>
              <Route index element={<Dashboard />} />
            </Route>

            <Route path='/user/list' element={<PrivateRouter />}>
              <Route index element={<UserManagement />} />
            </Route>

            <Route path='/user/detail' element={<PrivateRouter />}>
              <Route index element={<UserDetail />} />
            </Route>

            <Route path='/roles' element={<PrivateRouter />}>
              <Route index element={<RolesAndPermissions />} />
            </Route>

            <Route path='/manageRole/:id' element={<PrivateRouter />}>
              <Route index element={<ManageRolesAndPermissions />} />
            </Route>

            <Route path='/category' element={<PrivateRouter />}>
              <Route index element={<CategoryManagement />} />
            </Route>

            <Route path='/dropdown' element={<PrivateRouter />}>
              <Route index element={<DropdownManagement />} />
            </Route>

            <Route path='/callLogs' element={<PrivateRouter />}>
              <Route index element={<CallLogs />} />
            </Route>

            <Route path='/callStatus' element={<PrivateRouter />}>
              <Route index element={<CallStatus />} />
            </Route>

            <Route path='/viewUsers/:id' element={<PrivateRouter />}>
              <Route index element={<ViewUsers />} />
            </Route>

            <Route path='/knowledgeBase' element={<PrivateRouter />}>
              <Route index element={<KnowledgeBase />} />
            </Route>

            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            {/* <Route path="/user/list" element={<UserManagement />} />
            <Route path="/user/detail" element={<UserDetail />} /> */}


            <Route path="/settings" element={<SettingsLayout />}>

              <Route
                path="SMTP"
                element={<EmailSettings />}
              />

              <Route
                path="call"
                element={<CallSettings />}
              />

            </Route>

          </Route>

        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
